import { useEffect } from 'react';

// MUI Modal 기본 스크롤 락은 body 만 잠금. 포탈 화면은 뷰포트(html)가 실제 스크롤러라
// body → 뷰포트 overflow 전파가 먹지 않아 배경이 그대로 스크롤됨. html 을 직접 잠금.
// body 는 MUI 가 자체 저장/복원하므로 건드리지 않음(복원 순서 꼬임 방지).
let lockCount = 0;
let restoreOverflow = '';

/** 오버레이(바텀시트 등) 노출 중 배경 스크롤 잠금. 중첩 오픈은 카운트로 관리. */
const useScrollLock = (locked: boolean) => {
  useEffect(() => {
    if (!locked) return;

    const root = document.documentElement;
    if (lockCount === 0) {
      restoreOverflow = root.style.overflow;
      root.style.overflow = 'hidden';
    }
    lockCount += 1;

    return () => {
      lockCount -= 1;
      if (lockCount === 0) {
        root.style.overflow = restoreOverflow;
      }
    };
  }, [locked]);
};

export default useScrollLock;
